import { Component, Input, Renderer2, ViewChild } from '@angular/core';
import { ColumnHeader, GridStyle } from '../../../base/src/abcGrid/abcGrid';
@Component({
  selector: '',
  template: `<div class="example-container">
    <div class="example-table-container">
      <table
        #matGrid
        mat-table
        [dataSource]="gridData"
        class="mat-elevation-z8"
        style="width: 100% !important;"
        [style.width]="width"
        [style.height]="height"
        [class]="class"
      >
        <ng-container [matColumnDef]="column" *ngFor="let column of displayedColumns">
          <th mat-header-cell *matHeaderCellDef>{{ column }}</th>
          <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
      </table>
    </div>
    <mat-paginator [length]="100" [pageSize]="30"></mat-paginator>
  </div>`,
})
export class MatGridComponent {
  @ViewChild('matGrid', { static: true }) matGrid;
  @Input() id: string;
  @Input() columnsHeader: ColumnHeader[];
  @Input() gridData: any[];
  @Input() class?: string;
  @Input() width: string;
  @Input() height: string;

  columnsToDisplay: string[];
  displayedColumns: string[] = [];

  constructor(private renderer2: Renderer2) {}
  ngOnInit() {
    this.columnsHeader.forEach((element) => {
      this.displayedColumns.push(element.name);
    });
    this.columnsToDisplay = this.displayedColumns.slice();
  }

  ngAfterViewInit() {
    if (this.class) {
      const element = this.matGrid._elementRef.nativeElement;
      this.renderer2.addClass(element, this.class);
    }
  }

  setGridStyle(style: GridStyle) {
    const element = this.matGrid._elementRef.nativeElement;
    if (style) {
      for (let key in style) {
        element.style[key] = style[key];
      }
    }
  }

  addEventListener(
    type: string,
    listener: EventListenerOrEventListenerObject,
    options?: boolean | AddEventListenerOptions
  ) {
    const element: HTMLElement = this.matGrid._elementRef.nativeElement;
    element.addEventListener(type, listener, options);
  }
}
